/**
 * Module: story-hero
 * Handle story hero carousel functionality
 */

import Siema from 'siema';

var initialized_2d = false,
    initialized_3d = false,
    slides_selector = '.js-story-hero-slides',
    nav_selector = '.js-story-hero-nav',
    slide_selector = '.js-story-hero-slide',
    image_selector = '.js-story-hero-image',
    pages_selector = '.js-story-hero-pages',
    page_selector = '.js-story-hero-page',
    prev_selector = '.js-story-hero-prev',
    next_selector = '.js-story-hero-next',
    clone_class = 'js-story-hero-clone',
    slide_count = $( slide_selector ).length,
    index = slide_count,
    hero,
    $pages,
    $slides,
    $images;
    
function init() {
    if( 1 < slide_count ) {
        // Initialize 2D or 3D hero depending in initial window size
        if( 768 > window.innerWidth ) {
            init_2d();
        } else {
            init_3d();
        }

        // Initialize or destroy the hero on window resize
        $(window).resize( function() {
            if( 768 > window.innerWidth ) {
                destroy_3d();
                init_2d();
            } else {
                destroy_2d();
                init_3d();
            }
        });
    }
}

function init_2d() {
    if( !initialized_2d ) {
        $pages = $( page_selector );

        hero = new Siema({
            selector: slides_selector,
            onInit: function() {
                $pages.eq( this.currentSlide ).addClass('js-active');
            },
            onChange: function() {
                $pages.removeClass('js-active');
                $pages.eq( this.currentSlide ).addClass('js-active');
            }
        });
    }

    initialized_2d = true;
}

function destroy_2d() {
    if( initialized_2d ) {
        hero.destroy( true );
    }

    initialized_2d = false;
}

function init_3d() {
    if( !initialized_3d ) {
        // Add 3D class to container
        $( slides_selector ).addClass('js-story-hero-slides--3d');

        // Clone the slides to allow us to infinitely and smoothly loop through slides
        var clones = $( slide_selector ).clone();

        // Inform screen readers to skip the clones and designate them with a class for later removal
        $( clones ).attr('aria-hidden', 'true').addClass( clone_class );

        // Prepend and append the clones to the container
        $( slides_selector ).prepend( clones );
        $( slides_selector ).append( clones.clone() );

        // Cache jQuery collections
        $slides = $( slide_selector );
        $images = $( image_selector );

        // Add class to all slides
        $slides.addClass('js-story-hero-slide--standard');

        // Initalize navigation
        $( prev_selector ).on('click', () => prev() );
        $( next_selector ).on('click', () => next() );

        // Initialize slide classes
        apply_slide_classes();
    }

    initialized_3d = true;
}

function destroy_3d() {
    if( initialized_3d ) {
        // Remove class from container
        $( slides_selector ).removeClass('js-story-hero-slides--3d');

        // Remove clones
        $('.' + clone_class ).remove();

        // Remove class from slides
        $slides.removeClass('js-story-hero-slide--standard');

        // Remove navigation events
        $( prev_selector ).off();
        $( next_selector ).off();
    }

    initialized_3d = false;
}

function next() {
    if( ( slide_count * 2 ) == index ) {
        reset();
    }

    index++;
    apply_slide_classes();
}

function prev() {
    if( 0 == index ) {
        reset();
    }

    index--;
    apply_slide_classes();
}

function apply_slide_classes() {
    $slides.removeClass('js-story-hero-slide--current js-story-hero-slide--previous js-story-hero-slide--next js-story-hero-slide--last');

    $slides.eq( index ).addClass('js-story-hero-slide--current');
    $slides.eq( index - 1 ).addClass('js-story-hero-slide--previous');

    if( slide_count != 2 ) {
        $slides.eq( index + 1 ).addClass('js-story-hero-slide--next');
    } else {
        $slides.eq( index + 1 ).addClass('js-story-hero-slide--last');
    }

    if( slide_count > 2 ) {
        $slides.eq( index + 2 ).addClass('js-story-hero-slide--last');
    }
}

function reset() {
    // Reset the index to the starting position
    index = slide_count;

    // Disable the animation while we secretly rewind or fast forward the animation
    disable_animation();
    apply_slide_classes();
    enable_animation();
}

function disable_animation() {
    $slides.addClass('no-transitions');
    $images.addClass('no-transitions');
}

function enable_animation() {
    $slides[0].offsetHeight; // Trigger a reflow, flushing the CSS changes
    $slides.removeClass('no-transitions');
    $images.removeClass('no-transitions');
}

/**
 * Public API
 * @type {Object}
 */
module.exports = {
    init: init
};


// WEBPACK FOOTER //
// ./scripts/components/story.js